import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import SubscriptionDetails from '../../components/User/SubscriptionDetails';

const Subscription = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

useEffect(() => {
  console.log('Subscription Page Loaded');
  
  const allowDirectView = searchParams.get('redirect') === 'true';
  const token = searchParams.get('token');
  const fundraiserId = searchParams.get('fundraiserId');
  if (!allowDirectView && !token) {
    console.log('Direct view not allowed, redirecting to member-setup...');
    if (fundraiserId) {
      navigate(`/member-setup?fundraiserId=${fundraiserId}`, { replace: true });
    } else {
      navigate('/member-setup', { replace: true });
    }
  } else {
    console.log('Direct view allowed — staying on Subscription page');
  }
}, []);

  console.log('Rendering <SubscriptionDetails /> component');

  return <SubscriptionDetails />;
};

export default Subscription;


// import React, { useEffect, useState } from 'react';
// import { useNavigate, useSearchParams } from 'react-router-dom';
// import { useDispatch } from 'react-redux';
// import { getUserSubscription } from '../../services/subscriptionService';
// import SubscriptionDetails from '../../components/User/SubscriptionDetails';
// import Loader from '../../components/common/Loader';

// const Subscription = () => {
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const [searchParams] = useSearchParams();
//   const [checkingSub, setCheckingSub] = useState(true);

//   useEffect(() => {
//     const checkSubscription = async () => {
//       const allowDirectView = searchParams.get('redirect') === 'true';
//       const token = searchParams.get('token');
//       const fundraiserId = searchParams.get('fundraiserId');
//       try {
//         const result = await dispatch(getUserSubscription()).unwrap();
//         if (result?.success && result?.data?.length > 0) {
//           console.log("Existing subscription found. Redirecting...");
//           navigate('/existing-subscription', { replace: true });
//           return;
//         }
//       } catch (err) {
//         console.warn("Subscription check failed", err);
//       }

//       if (!allowDirectView && !token) {
//         console.log('Direct view not allowed, redirecting to member-setup...');
//         if (fundraiserId) {
//           navigate(`/member-setup?fundraiserId=${fundraiserId}`, { replace: true });
//         } else {
//           navigate('/member-setup', { replace: true });
//         }
//       } else {
//         console.log('Direct view allowed — staying on Subscription page');
//       }

//       setCheckingSub(false);
//     };

//     checkSubscription();
//   }, []);

//   if (checkingSub) return <Loader />;

//   return <SubscriptionDetails />;
// };

// export default Subscription;
